/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest =
  {
    ledgerCanisterId: string;
    index: number;
  };

/** @internal */
export const GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$inboundSchema:
  z.ZodType<
    GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    index: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$Outbound =
  {
    ledger_canister_id: string;
    index: number;
  };

/** @internal */
export const GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$outboundSchema:
  z.ZodType<
    GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$Outbound,
    z.ZodTypeDef,
    GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    index: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$ {
  /** @deprecated use `GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$inboundSchema;
  /** @deprecated use `GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$outboundSchema;
  /** @deprecated use `GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$Outbound` instead. */
  export type Outbound =
    GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$Outbound;
}

export function getSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequestToJSON(
  getSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest:
    GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest,
): string {
  return JSON.stringify(
    GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$outboundSchema
      .parse(
        getSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest,
      ),
  );
}

export function getSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetSnsTransactionImageApiV1ImagesLedgersLedgerCanisterIdTransactionsIndexPngGetRequest' from JSON`,
  );
}
